export default __webpack_public_path__ + "static/media/g.76b03e59.mp3";